import { gql } from '@apollo/client'

export default gql`
  query mortgageWidgetPrefillSubmission($loanType: WidgetLoanTypeEnum, $vertical: MortgageSubmissionVerticalEnum, $zipCode: String, $productTypes: [MortgageWidgetProductTypeEnum!]) {
    mortgageWidgetPrefillSubmission(loanType: $loanType, vertical: $vertical, zipCode: $zipCode) {
      uuid
      ficoType
      vertical
      zipCode
      loanType
      estimatedValue
      status
      downPayment
      homeValue
      loanAmount
      occupancyType
      propertyType
      cashOut
      products (productTypes: $productTypes){
        discount
        uuid
        externalProductId
        lender {
          name
          nmls
          slug
        }
        monthlyPayment
        loanTerm
        amortizationType
        productType
        rate
        apr
        fees
        bestProduct
      }
    }
  }
`
